import React        from "react";
import { Waypoint } from "react-waypoint";

import ImageComponent from "_components/molecules/imageComponent";
import ImageInfoModal from "_components/molecules/ImageInfoModal";
import useStyles      from "_styles/organisms/imagesTab";

const component = props => {

	const {
		isDataDepleted,
		isFetchingData,
		imageList = [],
		getNextData,
		handleImageModalClose,
		handleImageModalOpen,
		selectedImage,
		setSelectedImage,
		modalStatus,
		verticalFeedType,
		updateDeletedPost
	} = props;
	const { classes } = useStyles ( { listLength: imageList.length } );

	return (
		<div className = { classes.imagesTabWrapper }>

			{imageList?.map ( ( image, index, arr ) => {
				let conditionFlag   = arr.length % 3 ? arr.length % 3 : 3;
				let topLeftFlag     = index === 0;
				let topRightFlag    = index === 2;
				let bottomLeftFlag  = index === arr.length - conditionFlag && index % 3 === 0;
				let bottomRightFlag = index === arr.length - 1 && index % 3 === 2;

				return (
					<React.Fragment key = { index }>
						<ImageComponent
							bottomLeftFlag        = { bottomLeftFlag }
							bottomRightFlag       = { bottomRightFlag }
							handleImageModalOpen  = { handleImageModalOpen }
							image                 = { image }
							index                 = { index }
							setSelectedImage      = { setSelectedImage }
							topLeftFlag           = { topLeftFlag }
							topRightFlag          = { topRightFlag }
						/>

						{ !isDataDepleted && !isFetchingData && imageList.length > 0 && index === imageList.length - 2 && (
							<Waypoint
								onEnter = { () => getNextData ( ) }
							/>
						)}
					</React.Fragment>
				);
			} )}

			{selectedImage && modalStatus && (
				<ImageInfoModal
					handleImageModalClose = { handleImageModalClose }
					imageList             = { imageList }
					initialTabType        = { "comment" }
					modalStatus           = { modalStatus }
					selectedImage         = { selectedImage }
					setSelectedImage      = { setSelectedImage }
					totalLength           = { imageList?.length }
					updateDeletedPost     = { updateDeletedPost }
					verticalFeedType      = { verticalFeedType }
				/>
			)}
		</div>
	);
};

export default component;
